<div *ngIf="(race$ | async) as race">
  <mc-race-sync-progress-bar [race$]="race$"></mc-race-sync-progress-bar>

  <h1>{{ race.racePlan.name }} ({{race.racePlan.trackName}})</h1>

  <mc-ranking-selector
    [rankings]="rankings$ | async"
    [relativeRouterPath]="relativeRouterPath"
    [currentGroupId]="currentGroupId$ | async"
  ></mc-ranking-selector>

  <router-outlet></router-outlet>
</div>
